import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from '../../commons/shared.module';
import {ProjectsListComponent} from './projects.component';
import {ProjectEditorComponent, ProjectItem} from './project-editor.component';
import {ProjectTipsDialogComponent} from './project-tips-dialog/project-tips-dialog.component';
import { XsModule } from '@src/app/xs/xs.module';

const AppRoutes: Routes = [

    { path: '', component:ProjectsListComponent, pathMatch: 'full'},
  { path: 'map', loadChildren: () => import('../map/index').then(m => m.MapModule)},
    { path: ':projId', component:ProjectsListComponent, pathMatch: 'full'}
];


@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        XsModule,
        RouterModule.forChild(AppRoutes)
    ],

    declarations: [
        ProjectsListComponent,
        ProjectEditorComponent,
        ProjectItem,
      ProjectTipsDialogComponent

    ],
    entryComponents:[
        ProjectEditorComponent,
      ProjectTipsDialogComponent
    ]
})

export class DashboardModule {


}
